module.exports = __webpack_public_path__ + "static/img/QnLogo.0ec743e8.png";